<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('btn.edit') : t('btn.add')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="arkCode"
        :label="t('operate.6rj8gj')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CusSelect appId="cos_ofbu" v-model:value="editForm.arkCode" @selectData="selectData" :disabled="editForm.id" />
      </a-form-item>
      <a-form-item
        name="riskLevel"
        :label="t('operate.vztp8f')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <a-select ref="select" v-model:value="editForm.riskLevel" :placeholder="t('common.pleaseSelect')">
          <a-select-option :value="RISKLEVEL.LOW">{{ t('operate.5bdb1a') }}</a-select-option>
          <a-select-option :value="RISKLEVEL.MIDDLE">{{ t('operate.1xeaen') }}</a-select-option>
          <a-select-option :value="RISKLEVEL.HIGH">{{ t('operate.aft34c') }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiLoseWarning, updateBiLoseWarning } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiLoseWarningParams } from '@/typings/api/overseasSales'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { RISKLEVEL } from '../hooks/enum'
import { useI18n } from 'vue-i18n'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiLoseWarningParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiLoseWarningParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, riskLevel } = editForm.value
    const p = {
      arkCode,
      cosId,

      riskLevel
    }
    try {
      if (editForm.value.id) {
        await updateBiLoseWarning({ ...p, id: editForm.value.id })
      } else {
        await addBiLoseWarning(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
